import { DefaultTheme } from 'styled-components';

const dark: DefaultTheme = {
  title: 'dark',

  colors: {
    primary: '#24292e',
    secondary: '#fff',
  },

  background: {
    primary: '#ddd',
  },
};

export { dark };
